import type { JSX } from "react";
import type { CommonNavItemProps } from "./common-nav-item-props";
import { NavButton } from "./nav-button";
import { useNavItemActive } from "./use-nav-item-active";


export type NavItemRouteProps = CommonNavItemProps & {
	kind: "route";
	path: `/${string}`;
	matches?: (pathname: string) => boolean;
};
export const NavItemRoute = (item: NavItemRouteProps): JSX.Element => {
	return (
		<NavButton
			labelKey={ item.labelKey }
			icon={ item.icon }
			href={ item.path }
			active={ useNavItemActive(item) }
		/>
	);
};